export default __webpack_public_path__ + "static/media/kalamata_olive.775e0fe2.png";